import { useEffect, useState } from "react";

// Trình duyệt (Chrome/Edge Android & máy tính) bắn beforeinstallprompt rất sớm, có thể trước khi
// trang landing kịp render. Vì vậy bắt sự kiện ngay khi module được import (trong index.js)
// rồi giữ lại để nút "Cài app" gọi sau.
let deferredPrompt = null;
let installed = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault(); // Chặn thanh gợi ý mặc định, để tự hiện bằng nút của mình
        deferredPrompt = e;
        notify();
    });

    window.addEventListener("appinstalled", () => {
        installed = true;
        deferredPrompt = null;
        notify();
    });
}

const getUA = () => (typeof navigator !== "undefined" ? navigator.userAgent || "" : "");

export const isIOS = () =>
    /iPad|iPhone|iPod/.test(getUA()) ||
    // iPadOS 13+ giả làm Mac
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// Trình duyệt trong app Zalo / Facebook / Messenger / Instagram không cài được PWA
export const isInAppBrowser = () => /Zalo|FBAN|FBAV|FB_IAB|Messenger|Instagram/i.test(getUA());

export const isStandalone = () =>
    window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const promptInstall = async () => {
    if (!deferredPrompt) return null;
    const promptEvent = deferredPrompt;
    deferredPrompt = null; // Mỗi sự kiện chỉ gọi prompt() được 1 lần
    notify();
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    return outcome; // 'accepted' | 'dismissed'
};

export const usePwaInstall = () => {
    const [, setTick] = useState(0);

    useEffect(() => {
        const fn = () => setTick((t) => t + 1);
        listeners.add(fn);
        return () => listeners.delete(fn);
    }, []);

    return {
        canPrompt: !!deferredPrompt,
        isInstalled: installed || isStandalone(),
        isIOS: isIOS(),
        isInAppBrowser: isInAppBrowser(),
        promptInstall,
    };
};
